<!-- Player Album Info-->
<div class="player-controls">
    <player-info [album]="album" [trackId]="trackId" [albumPlayerType]="albumPlayerType"></player-info>
    <player-duration></player-duration>
    <player-controls [album]="album" [albumPlayerType]="albumPlayerType"></player-controls>
</div>